import React, { Dispatch, SetStateAction } from 'react';

type TCollectionsData = {
    elementId: number,
    sectionId: number,
    prevSectionId: number,
    items: {
        id: number;
        img: string;
        name: string;
        items: TCollectionsDataItem[];
    }[]
};

export type TCollectionsDataItem = {
    id: number;
    img: string;
    name: string;
};

type CollectionContextType = {
    collectionsData: TCollectionsData;

    setCollectionsData: Dispatch<SetStateAction<{
        elementId: number,
        sectionId: number,
        prevSectionId: number,
        items: {
            id: number;
            img: string;
            name: string;
            items: {
                id: number;
                img: string;
                name: string;
            }[];
        }[]
    }>>;
};

export const collectionsContext = React.createContext<CollectionContextType>({
    collectionsData: {
        elementId: 0,
        sectionId: 0,
        prevSectionId: 0,
        items: [{
            id: 0,
            img: '',
            name: '',
            items: [{
                    id: 0,
                    img: '',
                    name: '',
                }],
        }]
    },

    setCollectionsData: () => {},
});
